import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/img/zeronine.png';
import { Image } from '@chakra-ui/react';

const Footer = () => {
   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
   const [currentPage, setCurrentPage] = useState('home');
   const [activeSection, setActiveSection] = useState('home');

   const navigateToPage = (page) => {
      setCurrentPage(page);
      setActiveSection(page);
      setMobileMenuOpen(false);

      // Navigate to the route
      if (page === 'home') {
         window.location.href = '/';
      } else if (page === 'about') {
         window.location.href = '/about';
      }
   };
   const scrollToSection = (section) => {
      setMobileMenuOpen(false);
      if (currentPage !== 'home') {
         setCurrentPage('home');
         setTimeout(() => {
            document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
         }, 100);
      } else {
         document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
      }
   };

   return (
      <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-20 px-4">
         <style>{`
            .footer-link {
               position: relative;
               display: inline-block;
            }
            
            .footer-link::after {
               content: '';
               position: absolute;
               width: 0;
               height: 2px;
               bottom: -2px;
               left: 0;
               background: linear-gradient(90deg, #3b82f6, #8b5cf6);
               transition: width 0.3s ease;
            }
            
            .footer-link:hover::after {
               width: 100%;
            }
            
            .footer-link:hover {
               color: white;
               transform: translateX(4px);
            }

            .app-store-btn {
               transition: all 0.3s ease;
            }
            
            .app-store-btn:hover {
               transform: translateY(-3px);
               box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
            }
         `}</style>

         <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-4 gap-12 mb-16">
               <div>
                  <div className="flex items-center gap-3 mb-6">
                     <Image src={Logo} alt="ZeroNine Logo" width={'200px'} />
                  </div>
                  <p className="text-gray-400 mb-6 leading-relaxed">
                     India's most intelligent accounting software powered by AI
                  </p>
                  <div className="space-y-2 mb-6">
                     <p className="text-gray-400 text-sm">
                        <span className="font-semibold">Email :</span> info@zeronine.ai
                     </p>
                     <p className="text-gray-400 text-sm">
                        <span className="font-semibold">Phone :</span> +91 72839-90909
                     </p>
                  </div>
               </div>

               <div>
                  <h5 className="font-black mb-6 text-lg">Quick links</h5>
                  <ul className="space-y-3 text-gray-400">
                     <li>
                        <button
                           onClick={() => navigateToPage('home')}
                           className="footer-link transition-all duration-300">
                           Home
                        </button>
                     </li>
                     <li>
                        <Link to={'/about'} className="footer-link transition-all duration-300">
                           About Us
                        </Link>
                     </li>
                     <li>
                        <button
                           onClick={() => scrollToSection('pricing')}
                           className="footer-link transition-all duration-300">
                           Pricing
                        </button>
                     </li>
                     <li>
                        <button
                           onClick={() => scrollToSection('features')}
                           className="footer-link transition-all duration-300">
                           Features
                        </button>
                     </li>
                     <li>
                        <button
                           onClick={() => scrollToSection('testimonials')}
                           className="footer-link transition-all duration-300">
                           Reviews
                        </button>
                     </li>
                  </ul>
               </div>

               <div>
                  <h5 className="font-black mb-6 text-lg">Legal</h5>
                  <ul className="space-y-3 text-gray-400">
                     <li>
                        <Link to={'/termsofservice'} className="footer-link transition-all duration-300">
                           Terms of Service
                        </Link>
                     </li>
                     <li>
                        <Link to={'/privacypolicy'} className="footer-link transition-all duration-300">
                           Privacy Policy
                        </Link>
                     </li>
                     <li>
                        <Link to={'/refundpolicy'} className="footer-link transition-all duration-300">
                           Refund & Cancellation Policy
                        </Link>
                     </li>
                     <li>
                        <Link to={'/helpsupport'} className="footer-link transition-all duration-300">
                           Help & Support
                        </Link>
                     </li>
                  </ul>
               </div>

               {/* App Store Buttons */}
               <div>
                  <h6 className="font-semibold mb-3 text-sm">Download Our App</h6>
                  <div className="flex flex-row gap-2 flex-wrap">
                     <a
                        href="https://play.google.com/store/apps/details?id=com.ss.zeronine.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-store-btn inline-flex items-center gap-2 bg-black rounded-lg px-3 py-2 border border-gray-700 hover:border-blue-500">
                        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
                           <path
                              d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92z"
                              fill="#32BBFF"
                           />
                           <path d="M14.5 12.707l3.842 3.842-10.25 5.902 6.408-9.744z" fill="#F4B400" />
                           <path
                              d="M18.342 16.549l3.654-2.103c.394-.227.658-.594.658-1.063 0-.469-.264-.836-.658-1.063l-3.654-2.103-3.842 3.841 3.842 3.491z"
                              fill="#FF5B57"
                           />
                           <path d="M8.092 1.348L18.342 7.25l-3.842 3.842L8.092 1.348z" fill="#60D669" />
                        </svg>
                        <div className="text-left">
                           <p className="text-xs text-gray-400">GET IT ON</p>
                           <p className="text-xs font-semibold">Google Play</p>
                        </div>
                     </a>

                     <a
                        href="https://apps.apple.com/in/app/09-ai/id6747242947"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-store-btn inline-flex items-center gap-2 bg-black rounded-lg px-3 py-2 border border-gray-700 hover:border-blue-500">
                        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                           <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                        </svg>
                        <div className="text-left">
                           <p className="text-xs text-gray-400">Download on the</p>
                           <p className="text-xs font-semibold">App Store</p>
                        </div>
                     </a>
                  </div>
                  <div className="mt-6">
                     <h6 className="font-semibold mb-3 text-sm">Follow Us</h6>
                     <div className="flex gap-3">
                        {/* Instagram */}
                        <a
                           href="https://www.instagram.com/zeronine.ai_?igsh=bzI4ODB2cGFnYWY4"
                           target="_blank"
                           rel="noopener noreferrer"
                           className="social-icon inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 hover:shadow-lg hover:shadow-pink-500/50 transition-shadow"
                           aria-label="Follow us on Instagram">
                           <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                           </svg>
                        </a>

                        {/* YouTube */}
                        <a
                           href="https://www.youtube.com/@ZeronineAiTech"
                           target="_blank"
                           rel="noopener noreferrer"
                           className="social-icon inline-flex items-center justify-center w-10 h-10 rounded-full bg-red-600 hover:shadow-lg hover:shadow-red-500/50 transition-shadow"
                           aria-label="Follow us on YouTube">
                           <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                           </svg>
                        </a>

                        {/* Facebook */}
                        <a
                           href="https://www.facebook.com/profile.php?id=61586899329878"
                           target="_blank"
                           rel="noopener noreferrer"
                           className="social-icon inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-600 hover:shadow-lg hover:shadow-blue-500/50 transition-shadow"
                           aria-label="Follow us on Facebook">
                           <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                           </svg>
                        </a>

                        {/* LinkedIn */}
                        <a
                           href="https://www.linkedin.com/in/zeronine-ai-3864603a8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                           target="_blank"
                           rel="noopener noreferrer"
                           className="social-icon inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-700 hover:shadow-lg hover:shadow-blue-700/50 transition-shadow"
                           aria-label="Follow us on LinkedIn">
                           <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                           </svg>
                        </a>
                     </div>
                  </div>
               </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-800 text-center pb-5">
               <p className="text-gray-500 text-lg">Copyright © {new Date().getFullYear()} Zeronine Pvt. Ltd.</p>
            </div>
         </div>
      </footer>
   );
};

export default Footer;
